import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@pg-env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReferralService {
  private api = environment.customerApiUrl;
  private crmIntegrationApi = environment.crmIntegrationApiUrl;

  constructor(protected http: HttpClient) {
  }

  public getLeadTypes(): Observable<any> {
    const url: string = this.api + '/customer/lead-type-list';
    return this.http.get<any>(url);
  }

  public getProviderLists(): Observable<any> {
    const url: string = this.api + '/customer/provider-list';
    return this.http.get<any>(url);
  }

  public getClientLists(): Observable<any> {
    const url: string = this.api + '/customer/clientneed-list';
    return this.http.get<any>(url);
  }
  public getIndustry(): Observable<any> {
    const url: string = this.api + '/customer/industry-list';
    return this.http.get<any>(url);
  }
  addReferral(referral: any): Observable<any> {
    return this.http.post<any>(`${this.api}/customer/insert-referral`, referral);
  }
  uploadReferral(fileUpload: File): Observable<any> {
    const formData = new FormData();
    formData.append('', fileUpload, fileUpload.name);
    return this.http.post<any>(`${this.api}/customer/upload-referral-file`, formData, {
      headers: {
        useLocalHandleException: 'Y'
      }
    });
  }

  public downloadReferralTemplate(): Observable<any> {
    return this.http.get(`${this.api}/customer/download-referral-template`, { responseType: 'blob' });
  }

  public checkEmailExist(param): Observable<any> {
    return this.http.post(`${this.crmIntegrationApi}/account/Check-Email-CRM`, param);
  }
}
